import {  useLayoutEffect } from 'react';
import { SmallHeightDivider, WpRichTextContainer, } from '../../theme/Styles';
import { useDispatch } from 'react-redux';
import { UpdateAppSubHeaderTitle } from '../../redux/actions/UiActions';
import { Container } from './styles/TermsOfUseStyles';
import { useQuery } from 'react-query';
import CenterLoading from '../../components/CenterLoading/CenterLoading';
import { getTermsOfUse } from '../../api/TermsOfUse';
import parse from 'html-react-parser';

function TermsOfUse() {

  const dispatch = useDispatch();
  const { data: termsOfUseData, isLoading: termsOfUseDataIsLoading } = useQuery(['termsOfUseData'], () => getTermsOfUse());

  useLayoutEffect(() => {
    //UPDATE APP HEADER SUBTITLE
    dispatch(UpdateAppSubHeaderTitle("Términos de uso"));
  }, []);

  if (termsOfUseDataIsLoading) return <CenterLoading />;
  return (
    <Container>
      <SmallHeightDivider />
      <WpRichTextContainer>
        {
          termsOfUseData && parse(termsOfUseData?.content)
        }
      </WpRichTextContainer>
    </Container>
  );
}

export default TermsOfUse;
